import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Icon } from '../../../core/models/icon.model';
import { CurrencyBRLPipe } from '../../pipes/currency-brl.pipe';
import { I18nPipe } from '../../pipes/i18n.pipe';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'umkt-domain-promo',
  standalone: true,
  imports: [CommonModule, IconComponent, CurrencyBRLPipe, I18nPipe],
  templateUrl: './domain-promo.component.html',
  styleUrl: './domain-promo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DomainPromoComponent {
  @Input() domainName = '';
  @Input() isFree = false;
  @Input() price: number | null = null;
  @Input() priceText = '';
  @Input() icon: Icon = { name: 'celular', type: 'mondrian-icons' };
}
